import {Component} from 'react';
import { Button } from 'react-bootstrap';
import "./Admin/admin.css";
import getCurrentDateTime from '../../objects/CommonUse/get_current_date_time';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import GameFeedbackDisplayModal from './game_feedback_display_modal';
import PlayerFeedbackDisplayModal from './player_feedback_display_modal';
import GameProfileDisplayModal from './game_profile_display_modal';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import combinePlayerChoices from '../../objects/CommonUse/combine_player_choices';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import ExportToExcelButton from './export_to_excel';
import MoneyMgmtTestByQuestionModal from './money_mgmt_test_by_question_modal';
import MoneyMgmtTestByTopicModal from './money_mgmt_test_by_topic_modal';
import MoneyMgmtStudentTestModal from './money_mgmt_student_test_modal';
import ActivityTrackerAnalysisModal from './activity_tracker_analysis_modal';
import MonthlyStatusModal from '../game-views/monthly_status_modal';
import AwardsExtraCreditModal from './awards_extra_credit_modal';
import AwardPlayerDetailModal from './award_player_detail_modal';
import SelectClassModal from '../for-parents/select_class_modal';


class ClassReports extends Component {
    constructor(props) {
        super(props);
        this.adminInfo = this.props.adminInfo();
        this.state={
          headers: setHeadersForFetch(),  
          openSelectClass: false,
          selectAccountNbr: "All Accounts",
          loadGameFeedback: false,
          loadPlayerFeedback: false,
          openGameProfile: false,
          loadGameData: false,
          loadSavingsData: false,
          loadCreditCardData: false,
          loadTimeWizardData: false,
          gameChoicesData: null,
          openPMICalculator: false,
          loadJobChoiceData: false,
          loadHomeChoiceData: false,
          loadCarChoiceData: false,
          extraCreditLoaded: false,
          activityAnalysisRpt: false,
          subProcess: "ClassReports",
          environment: Config.dataURL.currentEnv,
          exportToExcelButton: false,
          testTopic: false,
          testQuestion: false,
          studentTest: false,
          openStatusModal: false,
          openAwardDetail: false
        };   
        this.waitState=false;
        this.gameFeedback = null;
        this.gameData = null;
        this.savingsData = null;
        this.creditCardData = null;
        this.timeWizardData = null;
        this.jobList = null;
        this.financialLiteracyTestData = null;
        this.activityTrackerData = null;
        this.loadGameChoicesData = false;
        this.selectAccountName = "All Accounts Selected";
    }

    openReportModal(feedbackType){
        this.openModal = true;
        this.gameRqstType = feedbackType;
        this.waitState = true;
        this.errorMsg = "";
        this.setState({exportToExcelButton: false});
        switch (feedbackType){
            case "selectClass":
                this.getAccountList();
                break;
            case "GameReviews":
                this.loadGameFeedback(feedbackType);
                break;
            case "Player":
                this.loadPlayerFeedback(feedbackType);
                break;
            case "gameProfile":
                if (this.state.selectAccountNbr === "All Accounts"){
                    this.waitState = false;
                    this.errorMsg = "Report not valid for all accounts, select another account";
                }else{
                    this.loadGamesForAccount();
                }
                this.setState({openGameProfile: true});
                break;
            case "testQuestion":
            case "testTopic":
            case "studentTest":
                this.loadStudentTests(feedbackType);
                break;
            case "activityAnalysis":
                this.setState({activityAnalysisRpt: false});
                if (this.state.selectAccountNbr === "All Accounts"){
                    this.loadActivityTracker();
                }else{
                    this.loadGamesForAccount();
                }
                break;
            case "awardExtraCredit":
                if (this.state.selectAccountNbr === "All Accounts"){
                    this.waitState = false;
                    this.errorMsg = "Report not valid for all accounts, select another account";
                }else{
                    this.loadGamesForAccount();
                }
                break;
            default:
                break;
        }
    }

    closeReportModal(modalType){
        this.openModal = false;
        switch (modalType){
            case "selectClass":
                this.setState({openSelectClass: false});
                break;
            case "gameFeedback":
                this.setState({loadGameFeedback: false})
                break;
            case "playerFeedback":
                this.setState({loadPlayerFeedback: false});
                break;
            case "gameData":
                this.setState({loadGameData: false});
                break;
            case "testQuestion":
                this.setState({testQuestion: false});
                break;
            case "testTopic":
                this.setState({testTopic: false});
                break;
            case "studentTest":
                this.setState({studentTest: false});
                break;
            case "analyzeActivityTracker":
                this.setState({activityAnalysisRpt: false});
                break;
            case "monthlyStatus":
                this.openModal = true;
                this.setState({openStatusModal: false, openGameProfile: true});
                break;
            case "awardExtraCredit":
                this.setState({getProfileParms: false});
                break;
            case "awardPlayerDetail":
                this.gameRqstType = "awardExtraCredit"; 
                this.openModal = true;
                this.setState({openAwardDetail: false});
                break;
            default:
                break;
        }
        this.waitState = false;
    }
     
    exportReportsDataset() {
        this.setState({exportToExcelButton: true});    
    }

    removeExportButton(){
        this.setState({exportToExcelButton: false});
    }

    displayStatus(playerName)
    {
        for (let i=0; i<this.gameData.length; i++){
            let gameData = this.gameData[i];
            if (gameData.user === playerName){
                this.props.setAdminInfo(gameData, "gameData");
                break;
            }
        }
        this.setState({openStatusModal: true, openGameProfile: false});
    }

    closeStatusModal(){
        this.openProcessName = "GameProfile"
        this.setState({openStatusModal: false});
    }

    displayPlayerAwardDetail(player){
        this.closeReportModal("awardExtraCredit");
        this.playerName = player;
        const extraIndx = this.extraCreditArr.findIndex(elem => elem.user === player);
        if (extraIndx === -1){
            this.playerExtraCredit = {};
        }else{
            this.playerExtraCredit = this.extraCreditArr[extraIndx].extraCreditTable;
        }
        const achieveIndx = this.achievements.findIndex(elem => elem.user === player);
        if (achieveIndx === -1){
            this.playerAchievements = {};
        }else{
            this.playerAchievements = this.achievements[achieveIndx].achievementArr;
        }
        const badgeIndx = this.badgeArr.findIndex(elem => elem.user === player);
        if (badgeIndx === -1){
            this.playerBadges = {};
        }else{
            this.playerBadges = this.badgeArr[badgeIndx].badgesEarned;
        }
        this.setState({openAwardDetail: true});
    }

     filterByReviewCode(reviewCode){
        this.filterPlayerFeedback = JSON.parse(JSON.stringify(this.playerFeedback));
        if (reviewCode === "all"){
            //  no filter is applied - select all
        }else{
            if (reviewCode === "99"){
                this.filterPlayerFeedback = this.playerFeedback.filter(elem => elem.reviewed === undefined);
            }else{
                this.filterPlayerFeedback = this.playerFeedback.filter(elem => elem.reviewed.code === reviewCode)
            }
        }
        this.setState({displayFeedback: !this.state.displayFeedback});
    }
                
    render() {
        if(this.state.loadJobChoiceData === true && this.state.loadHomeChoiceData === true &&
           this.state.loadCarChoiceData === true){
                this.allChoicesArr = combinePlayerChoices(this.gameChoiceArr, this.jobChoiceData,
                    this.homeChoiceData, this.carChoiceData);
                this.waitState = false;
                this.loadGameChoicesData = true;
        }
        let openRqstType = "";
        if (this.gameRqstType === "awardExtraCredit" && this.state.loadGameData === true &&
            this.state.extraCreditLoaded === true){
                this.waitState = false;
                openRqstType = this.gameRqstType;
        }
        if (this.gameRqstType === "gameProfile" &&
            this.state.loadGameData === true && this.state.loadCreditCardData === true &&
            this.state.loadSavingsData === true && this.loadGameChoicesData === true &&
            this.state.loadTimeWizardData === true){
                this.waitState = false;
            }
    return <>
           <div className="col-sm-6 mb-5 input-page-base-card">
                <div className="card mt-3 mr-5 rounded-corners-lg height-max">
                    <h1 className="mt-3 p-0 text-center">Game Administration</h1>
                    <h4 className="text-center">Class and Player Reports</h4>
                    <div className="mt-2 ml-2 row">
                        <div className="col-6 text-left ml-4">
                            <div><b>Account Number:&nbsp; 
                                </b> {this.state.selectAccountNbr} </div>
                            <div>{this.selectAccountName}</div>
                        </div>
                        <div className="col-5">
                            <Button variant="primary" className="py-0"
                                onClick={() => this.openReportModal("selectClass")}>
                                    Select A Different Account 
                            </Button>
                        </div>
                    </div>
                    <table className="row-100  ml-2 mt-4 overflow-scroll">
                        <tbody className="w-40">
                            <tr>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide" 
                                        onClick ={()=> this.openReportModal("GameReviews")}>
                                            Player Game Reviews
                                    </button>
                                </td>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("Player")}>
                                            Player Comments
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className="col-sm-6 text-center">
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("gameProfile")}>
                                            Game Profiles
                                    </button>
                                </td>
                                <td className="col-sm-6 text-center" >
                                        <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("activityAnalysis")}>
                                                Analyze Activities
                                        </button>
                                </td>
                            </tr>
                            <tr>
                                <td className="col-sm-6 text-center" >
                                    <button className="btn-group-wide mt-2" 
                                      onClick ={()=> this.openReportModal("studentTest")}>
                                            Student Test Results
                                    </button>
                                </td>
                                <td className="col-sm-6 text-center" >
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("testTopic")}>
                                            Test Topic Assessment
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td className="col-sm-6 text-center" >
                                    <button className="btn-group-wide mt-2" 
                                        onClick ={()=> this.openReportModal("testQuestion")}>
                                            Test Question Review
                                    </button>
                                </td>
                                <td className="col-sm-6 text-center" >
                                    <button className="btn-group-wide mt-2" 
                                      onClick ={()=> this.openReportModal("awardExtraCredit")}>
                                           Award & Extra Credit Rpt
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="font-weight-bold text-danger text-center mt-4">
                        {this.errorMsg}
                    </div>
                    
                    {this.waitState ?
                      <div className="text-center mt-3">
                            <WaitTimeSpinner/>
                            <div className="mt-3 text-white">testing</div>
                            <h3 className="mt-2">This may take a few minutes to load.</h3>
                        </div>
                    :
                        null
                    }
                      
                    {this.state.openSelectClass ?
                        <SelectClassModal
                            show={this.state.openSelectClass}
                            accountNbr={this.state.selectAccountNbr}
                            accountList={this.accountList}
                            onClose={() => this.closeReportModal("selectClass")}
                            changeClassCode={(newClassCode) => 
                                this.changeClassCode(newClassCode)}
                        />
                    :
                        null
                    }

                    {this.state.loadGameFeedback ?
                        <span>
                            <GameFeedbackDisplayModal openModal={this.openModal} 
                                    onClose={() => this.closeReportModal("gameFeedback")} 
                                    gameFeedback={this.gameFeedback}
                            />
                        </span>
                    :
                        null
                    }

                    {this.state.loadPlayerFeedback ?
                        <PlayerFeedbackDisplayModal openModal={this.openModal} 
                            onClose={() => this.closeReportModal("playerFeedback")} 
                            commentsOnly={false}
                            playerFeedback={this.filterPlayerFeedback}
                            filterByReviewCode={(reviewCode) => this.filterByReviewCode(reviewCode)}
                        />
                    :
                        null
                    }

                    {this.state.loadGameData && this.state.loadSavingsData && this.state.loadCreditCardData 
                        && this.state.loadTimeWizardData && this.loadGameChoicesData && this.state.openGameProfile ?
                            <GameProfileDisplayModal openModal={this.openModal} 
                                onClose={() => this.closeReportModal("gameData")} 
                                gameData={this.gameData}
                                savingsData={this.savingsData}
                                creditCardData={this.creditCardData}
                                timeWizardData={this.timeWizardData}
                                gameChoicesData={this.allChoicesArr}
                                displayStatus = {(player) => this.displayStatus(player)}
                            />
                    :
                        null
                    }

                    {this.state.openStatusModal ?
                        <MonthlyStatusModal modalOpen={this.state.openStatusModal} 
                            fromProcess={"report"}
                            onClose={() => this.closeReportModal("monthlyStatus")} 
                            onNavigate={(pathname) => this.props.onNavigate(pathname)}
                            gameInfo = {() => this.props.adminInfo()}
                        />
                    :
                        null
                    }

                    {this.state.studentTest ?
                        <MoneyMgmtStudentTestModal
                            openModal={this.openModal}
                            accountNbr={this.state.selectAccountNbr}
                            accountName={this.selectAccountName}
                            financialLiteracyTestArr={this.financialLiteracyTestData}
                            onClose={() => this.closeReportModal("studentTest")} 
                        />
                    :
                        null
                    }

                    {this.state.testTopic ?
                        <MoneyMgmtTestByTopicModal
                            openModal={this.openModal}
                             accountNbr={this.state.selectAccountNbr}
                            accountName={this.selectAccountName}
                            financialLiteracyTestArr={this.financialLiteracyTestData}
                            onClose={() => this.closeReportModal("testTopic")} 
                        />
                    :
                        null
                    }
                    
                    {this.state.testQuestion ?
                        <MoneyMgmtTestByQuestionModal
                            openModal={this.openModal}
                            accountNbr={this.state.selectAccountNbr}
                            accountName={this.selectAccountName}
                            financialLiteracyTestArr={this.financialLiteracyTestData}
                            onClose={() => this.closeReportModal("testQuestion")} 
                        />
                    :
                        null
                    }
              
                    {this.state.activityAnalysisRpt  ?
                        <ActivityTrackerAnalysisModal
                            show={this.state.activityAnalysisRpt}
                            accountNbr={this.state.selectAccountNbr}
                            activityTrackerData={this.activityTrackerData}
                            onClose={() => this.closeReportModal("analyzeActivityTracker")} 
                            />
                    :
                        null
                    }

                    {openRqstType === "awardExtraCredit"  ?
                        <AwardsExtraCreditModal 
                            openModal={this.openModal}
                            extraCredit={this.extraCreditArr}
                            achievements={this.achievements}
                            badgesArr={this.badgeArr}
                            onClose={() => this.closeReportModal("awardExtraCredit")}
                            playerAwardDetail={(player) => this.displayPlayerAwardDetail(player)}
                        />
                    :
                        null
                    }

                    {this.state.openAwardDetail   ?
                         <AwardPlayerDetailModal 
                            openModal={this.state.openAwardDetail}
                            player={this.playerName}
                            extraCredit={this.playerExtraCredit}
                            achievements={this.playerAchievements}
                            badges={this.playerBadges}
                            onClose={() => this.closeReportModal("awardPlayerDetail")}
                        />
                    :
                        null
                    }
                                                         
                    </div>
                    {this.state.exportToExcelButton ?
                        <ExportToExcelButton
                            fileName={this.rptTitle}
                            rptHeader={this.rptHeader}
                            data={this.rptLines}
                            exportComplete={() => this.removeExportButton()}
                        />
                    :
                        null
                    }
               
                   
                </div>        
        
        </>
    }

getAccountList() {
    // retrieve all accounts where userName is an accountOwner
    const userName = "All";
    const funcName = "loadAccountList";
    const urlParm = "?userName=" + userName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.accountList = this.createAccountList(output.body, userName);
                        this.waitState = false;
                        this.setState({openSelectClass: true});
                    }else{  
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
}

createAccountList(accountList, userName){
    let accountListArr = [];
    const dateTime = getCurrentDateTime();
    //  add 'All Accounts' to the list
    const allAccountObj = {accountNbr: "All Accounts", className: "Select All Users/Players", dateAssigned: dateTime.date};
    accountListArr.push(allAccountObj);
    // add 'Individual' to the list
    const individualObj = {accountNbr: "Individual", className: "Individuals without an Account",
            dateAssigned: dateTime.date};
    accountListArr.push(individualObj);
      
    for (let i=0; i<accountList.length; i++){
        const teacherObj = accountList[i].accountOwnerArr.find(elem => elem.username === userName);
        let dateAssigned = dateTime.date;
        if (teacherObj){
              dateAssigned = teacherObj.dateUpdated;
        }
        let className = "";
        if (accountList[i].className === undefined){
            const houseHoldAccount = accountList[i].rqstdUsersArr.find(elem => elem.role === "parent");
            if (houseHoldAccount){
                className = "Household Account";
            }
        }else{
            className = accountList[i].className;
        }
        const accountListObj = {accountNbr: accountList[i].accountNbr, className: className,
            dateAssigned: dateAssigned}
        accountListArr.push(accountListObj);
    }
    return accountListArr;
}

changeClassCode(accountNbr){
    // this.getPlayerAccount(accountNbr);
    if (accountNbr !== "All Accounts"){
        this.getUserList(accountNbr);
    }else{
        this.setState({openSelectClass: false});
    }
    this.selectAccountName = this.accountList.find(elem => elem.accountNbr === accountNbr).className;
    this.setState({selectAccountNbr: accountNbr});
}

getUserList(accountNbr){
    const funcName = "userCollectionList";
    const urlParm = "?accountNbr=" + accountNbr + "&test=test";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.buildPlayerArr(output.body);
                        this.setState({openSelectClass: false});
                    }else{  
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.processErrorReturn(errorObj);
                    }
                });
            };
        });
}
 
buildPlayerArr(data){
    let playerArr = [];
    let userArr = data;
    for (let i=0; i<userArr.length; i++){
        playerArr.push(userArr[i].username);
    }
    this.relatedPlayers = playerArr;
}

loadGameFeedback(feedbackType){
    let urlParm = "";
    if (this.state.selectAccountNbr !== "All Accounts"){
        let userNameArr = (this.relatedPlayers).join(',');
        urlParm = "?userList=" + userNameArr;
    }
    const funcName = "loadGameFeedback";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.gameFeedback = output.body;
                        this.rptType = feedbackType;
                        this.waitState = false;
                        this.setState({loadGameFeedback: true})
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

loadPlayerFeedback(reportName){
    let urlParm = "";
    if (this.state.selectAccountNbr !== "All Accounts"){
        let userNameArr = (this.relatedPlayers).join(',');
        urlParm = "?userList=" + userNameArr;
    }
    const funcName = "loadPlayerFeedback";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
       {method:'GET', headers: this.state.headers})
       .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.sortPlayerFeedback(output.body, reportName);
                    this.setState({loadPlayerFeedback: true});
                    this.waitState = false;
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}

sortPlayerFeedback(playerFeedback, reportName){
    this.playerFeedback = [];
    for (let i=0; i<playerFeedback.length; i++){
        let sortKey = "";
        if (reportName === "Player"){
            sortKey = playerFeedback[i].user + playerFeedback[i].dateAdded + playerFeedback[i].timeAdded;
        }else{
            if (!playerFeedback[i].reviewed){
                playerFeedback[i] = {...playerFeedback[i], reviewed: {code: 0, dateAdded: 12/31/99}};
            }
            sortKey = playerFeedback[i].reviewed.code + playerFeedback[i].dateAdded +
                playerFeedback[i].timeAdded;
        }
        let feedbackObj = {...playerFeedback[i], sortKey: sortKey};
        this.playerFeedback.push(feedbackObj);
    }
    (this.playerFeedback).sort((a, b) => (a.sortKey > b.sortKey) ? 1 : -1);
    this.filterPlayerFeedback = JSON.parse(JSON.stringify(this.playerFeedback));
}

loadGamesForAccount(){
    this.setState({loadGameFeedback: false, openGameProfile: true, waitState: true});
    let userNameArr = (this.relatedPlayers).join(',');
    const funcName = "loadGamesForAccount";
    const urlParm = "?userNameArr=" + userNameArr;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        (output.body).sort((a, b) => (a.user > b.user) ? 1 : -1)
                        this.gameData = output.body;
                        switch (this.gameRqstType){
                            case "gameProfile":
                                this.setGameIdArr();
                                this.loadSavings();
                                this.loadCreditCardInfo();
                                this.loadTimeWizardInfo();
                                this.loadGameChoices();
                                break;
                            case "activityAnalysis":
                                this.loadActivityTracker();
                                break;
                            case "awardExtraCredit":
                                this.loadExtraCredit();
                                this.buildAwardArrays();
                                break;
                            default:
                                break;
                        }
                        this.setState({loadGameData: true})
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
}

setGameIdArr(){
    this.gameIdArr = [];
    this.gameChoiceArr = [];
    for (let i=0; i<this.gameData.length; i++){
          this.gameIdArr.push(this.gameData[i]._id);
          let gameChoiceObj = {gameID:this.gameData[i]._id, jobID:this.gameData[i].jobInfo.careerID,
            homeID:this.gameData[i].homeInfo.homeID, carID:this.gameData[i].carInfo.carID};
          this.gameChoiceArr.push(gameChoiceObj);
    }
}

buildAwardArrays(){
    this.badgeArr = [];
    this.achievements = [];
    for (let i=0; i<this.gameData.length; i++){
        const game = this.gameData[i];
        const badgeObj = {user: game.user, badgesEarned: game.badgesEarned};
        this.badgeArr.push(badgeObj);
        const achievementObj = {user: game.user, achievementArr: game.achievementArr};
        this.achievements.push(achievementObj);
    }
}

loadSavings() {
    let gameID = (this.gameIdArr).join(',');
    const funcName = "loadSavings";
    const urlParm = "?gameID=" + gameID + "&returnType=Multiple"; 
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                   this.savingsData = output.body;
                    this.setState({loadSavingsData: true});
                   
                }else{
                    if (statusCode === 250){
                       this.savingsData = [];
                        this.setState({loadSavingsData: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}

loadCreditCardInfo() {
    let gameID = (this.gameIdArr).join(',');
    const funcName = "loadCreditCardInfo";
    const urlParm = "?gameID=" + gameID + "&returnType=Multiple"; 
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
   
    {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                   this.creditCardData = output.body;
                    this.setState({loadCreditCardData: true});
                }else{
                    if (statusCode === 250){
                       this.creditCardData = [];
                        this.setState({loadCreditCardData: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}

loadTimeWizardInfo() {
    let gameID = (this.gameIdArr).join(',');
    const funcName = "loadTimeWizard";
    const urlParm = "?gameID=" + gameID + "&returnType=Multiple"; 
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
   
    {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                   this.timeWizardData = output.body;
                    this.setState({loadTimeWizardData: true});
                }else{
                    if (statusCode === 250){
                       this.timeWizardData = [];
                       this.setState({loadTimeWizardData: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
        };
    });
}

loadGameChoices(){
    this.loadJobChoices();
    this.loadHomeChoices();
    this.loadCarChoices();
  }
  
loadJobChoices(){
    let jobIdArr=[];
    for (let i=0; i<this.gameChoiceArr.length; i++){
          jobIdArr.push(this.gameChoiceArr[i].jobID);
    }
    const jobIdParm = jobIdArr.join(',');
    const funcName = "jobInfo";
    const urlParm = "?jobId=" + jobIdParm + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.jobChoiceData = output.body;
                    this.setState({loadJobChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
  }

  
loadHomeChoices(){
    let homeIdArr=[];
    for (let i=0; i<this.gameChoiceArr.length; i++){
          homeIdArr.push(this.gameChoiceArr[i].homeID);
    }
    const homeIdParm = homeIdArr.join(',');
    const funcName = "homeInfo";
    const urlParm = "?homeId=" + homeIdParm + "&returnType=Multiple";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.homeChoiceData = output.body;
                    this.setState({loadHomeChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
  }
    
loadCarChoices(){
    let carIdArr=[];
    for (let i=0; i<this.gameChoiceArr.length; i++){
          carIdArr.push(this.gameChoiceArr[i].carID);
    }
    const carIdParm = carIdArr.join(',')
    const funcName = "carInfo";
    const urlParm = "?carId=" + carIdParm + "&returnType=Multiple";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri, 
        {method:'GET', 
        headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.carChoiceData = output.body;
                    this.setState({loadCarChoiceData: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                    this.props.processError(errorObj);
                }
            });
        };
    });
}
  
  loadStudentTests(reportType){
    this.setState({waitState: true});
    let urlParm = "";
    if (this.state.selectAccountNbr !== "All Accounts"){
        const playerArr = (this.relatedPlayers).join(',');  
        urlParm = "?userArr=" + playerArr;
    }
    const funcName = "loadFinancialLiteracyTest";
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch(uri,
        {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                       this.financialLiteracyTestData = output.body;
                       this.financialLiteracyTestData = 
                           this.financialLiteracyTestData.sort((a, b) => (a.user + a.dateAdded > b.user + b.dateAdded) ? 1 : -1);
                        this.waitState = false;
                        switch (reportType){
                            case "testTopic":
                                this.setState({testTopic: true});
                                break;
                            case "testQuestion":
                                this.setState({testQuestion: true});
                                break;
                            default:
                                this.setState({studentTest: true});
                                break;
                        }
                    }else{
                        if (statusCode === 250){
                            alert("There is no student test data for this parent/teacher.")
                                        
                        }else{
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                    status: statusCode, message: output.body.message};
                            this.props.processError(errorObj);
                        }
                    }
                });
            };
        });
  }

  loadActivityTracker(){
    const funcName = "loadAllGameActivityTracker";
    let urlParm = "";
    if (this.state.selectAccountNbr !== "All Accounts"){
        let gameIdArr = [];
        for (let i=0; i<this.gameData.length; i++){
            gameIdArr.push(this.gameData[i]._id);
        }
        const gameIdList = gameIdArr.join(",");
        urlParm = "?gameID=" + gameIdList;
    }
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,
         {method:'GET', headers: this.state.headers})
         .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    // fetch of game activity tracker was successful;
                    this.activityTrackerData = output.body;
                    this.waitState = false;
                    this.setState({activityAnalysisRpt: true});
                    
                }else{
                    if (statusCode === 250){
                        // fetch successful but no record found;
                        alert("No Activity Tracker Data Found");
                        this.waitState = false;
                        this.setState({activityAnalysisReport: true});
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                }
            });
            }
    });
}
    
loadExtraCredit(){
      const funcName = "loadMultipleExtraCredit";
      //  if parm is spaces, then will load all extra credit records (no student selection)
      let userList = this.relatedPlayers.join(',');
      const urlParm = "?userArr=" + userList;
      const uri = buildUrl(this.state.environment, funcName, urlParm);
      fetch (uri,
          {method:'GET', headers: this.state.headers})
          .then(response => {
              if (response.ok){
                  response.json().then(data => {
                  const output = JSON.parse(data);
                  const statusCode = output.statusCode;
                  if (statusCode === 200){
                      // fetch of extra credit was successful;
                      this.extraCreditArr = output.body;
                      this.waitState = false;
                      this.setState({extraCreditLoaded: true});
                      
                  }else{
                      if (statusCode === 250){
                          // fetch successful but no record found;
                          this.extraCreditArr = [];
                          this.achievements = [];
                          this.waitState = false;
                          this.setState({extraCreditLoaded: true});
                      }else{
                          const errorObj={function: funcName, subProcess: this.state.subProcess, 
                              status: statusCode, message: output.body.message};
                          this.props.processError(errorObj);
                      }
                  }
              });
              }
      });
  }

 

}

export default ClassReports;